// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

//4.15新增路由
//大模型接入
import largemodel from '@/views/largemodel/setting';
import strategy from '@/views/strategy/index';
import data from '@/views/data/data';
import knowledge from '@/views/knowledge/index';
import chatAPI from '@/views/chat/api';
import chatWEB from '@/views/chat/web';
import chatBOT from '@/views/chat/bot';
import bot_add from '@/views/chat/bot_add';
import web_add from '@/views/chat/web_add';
import chatapi from '@/views/system/api';


// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/chat/web',
            name: 'chatWEB',
            component: chatWEB,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/Machine',
            name: '机器信息管理',
            component: Machine,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineAisle',
            name: '货道信息管理',
            component: MachineAisle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineConfig',
            name: '支付配置信息',
            component: MachineConfig,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Config',
            name: '支付配置',
            component: Config,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }
        , {
            path: '/largemodel/setting',
            name: '大模型接入',
            component: largemodel,
            meta: {
                requireAuth: true
            }
        }
        , {
            path: '/system/api',
            name: '大模型接入',
            component: chatapi,
            meta: {
                requireAuth: true
            }
        },
        
        , {
            path: '/strategy/index',
            name: '开放平台策略',
            component: strategy,
            meta: {
                requireAuth: true
            }
        }
        , {
            path: '/knowledge/index',
            name: '知识库',
            component: knowledge,
            meta: {
                requireAuth: true
            }
        }
        , {
            path: '/data/data',
            name: '访问数据',
            component: data,
            meta: {
                requireAuth: true
            }
        }
        , {
            path: '/chat/web',
            name: 'chatWEB',
            component: chatWEB,
            meta: {
                requireAuth: true
            }
        }
        , {
            path: '/chat/web_add',
            name: 'chatWEB新增',
            component: web_add,
            meta: {
                requireAuth: true
            }
        }
        , {
            path: '/chat/bot',
            name: 'chatBOT',
            component: chatBOT,
            meta: {
                requireAuth: true
            }
        }
        , {
            path: '/chat/bot_add',
            name: 'chatBOT新增',
            component: bot_add,
            meta: {
                requireAuth: true
            }
        }
        , {
            path: '/chat/api',
            name: 'chatAPI',
            component: chatAPI,
            meta: {
                requireAuth: true
            }
        }
    
    ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js